import React from "react";
// import {useField} from "formik";
import {FieldFeedbackLabel} from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid-select");
  }

  if (touched && !errors) {
    classes.push("is-valid-select");
  }

  return classes.join(" ");
};
// function getValidChildren(children) {
//   return React.Children.toArray(children).filter((child) =>
//     React.isValidElement(child)
//   );
// }

export function Select({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  children,
  categoryName,
  ...props
}) {
  return (
    <>
      {label && <label>{label}</label>}
      <select
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
      >
        <option disabled={true} value="">Choose {" "} {categoryName}</option>
        {children}
      </select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
